import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCamera, faRotate, faExclamation } from '@fortawesome/free-solid-svg-icons';
import { post } from '../../utils/api';
import getFileURL from '../../utils/getFileURL';
import './AvatarForm.css';
import { authUpdateUserAvatar } from '../../store/authSlice';
import { File } from '../../types';

const AvatarForm = () => {
    const user = useAppSelector(store => store.auth.user);
    const dispatch = useAppDispatch();
    const [ avatar, setAvatar ] = useState(getFileURL(user?.avatar));
    const [ isLoading, setIsLoading ] = useState(false);
    const [ icon, setIcon ] = useState(faCamera);
    const [ iconClass, setIconClass ] = useState<string|undefined>(undefined);

    useEffect(() => {
        setAvatar(getFileURL(user?.avatar));
    }, [ user ]);

    const onFileChange = async (files: FileList | null) => {
        if(!files) return;
        setIsLoading(true);
        setIcon(faRotate);
        setIconClass('fa-spin');
        const formData = new FormData();
        formData.append('image', files[0], files[0].name);
        const result = await post('/files', formData);
		if(result.error) {
            setIcon(faExclamation);
            setIconClass('error');
        } else {
            setIcon(faCamera);
            setIconClass('success');
            // Также необходимо обновить информацию о пользователе в сторе
            if(user) {
                dispatch(authUpdateUserAvatar((result.data?.file as File).id));
            }
        }
        setIsLoading(false);
    };

	return (
		<div className='AvatarForm' style={{ backgroundImage: 'url(' + avatar + ')'}}>
	        <label htmlFor='image'/>
            <div className='icon'><Icon className={iconClass} icon={icon}/></div>
	        <input
                id='image'
                type='file'
                accept='image/jpeg, image/png, image/gif'
                onChange={(e) => onFileChange(e.target.files)}
                disabled={isLoading}
            />
		</div>
	);
};

export default AvatarForm;
